import React from 'react';
import PropTypes from 'prop-types';
import LoginLocales from './LoginLocales';
import LoginLogo from './LoginLogo';
import { getLogoBackground } from '../utils/cssUtil';

const LoginElementsHeader = (props) => {
    const {
        contextCls,
        isInteractive,
        loginConfig,
        onLocaleSelect,
        theme,
        supportedLocales,
        legacyLoginConfig,
    } = props;

    return (
        <div
            className={`${contextCls}__login-elements-header`}
            style={getLogoBackground(loginConfig, theme)}
        >
            <LoginLocales
                contextCls={`${contextCls}__locale-container`}
                isInteractive={isInteractive}
                supportedLocales={supportedLocales}
                onLocaleSelect={onLocaleSelect}
            />
            <LoginLogo
                legacyLoginConfig={legacyLoginConfig}
                theme={theme}
                contextCls={`${contextCls}__logo`}
            />
        </div>
    );
};

LoginElementsHeader.defaultProps = {};

LoginElementsHeader.propTypes = {
    contextCls: PropTypes.string,
    loginConfig: PropTypes.object,
    theme: PropTypes.object,
    isInteractive: PropTypes.bool,
    onLocaleSelect: PropTypes.func,
    supportedLocales: PropTypes.array,
    legacyLoginConfig: PropTypes.object,
};

export default LoginElementsHeader;
